import { ToastContainer as ReactToastifyContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ToastContainer = () => {
  return (
    <ReactToastifyContainer
      limit={3}
      newestOnTop={false}
      closeOnClick
      pauseOnHover
      hideProgressBar
      icon={false}
    />
  );
};

export default ToastContainer;
